import { useTranslation } from 'next-i18next';
import { Divider, Spacing } from '@zep/ui';
import { usePlanPaymentFormContext } from '../../PlanPaymentSection/Providers';
import { PlanTemplateType } from '../../types';
import { CardPaymentRegisterSection } from './CardPaymentRegisterSection';
export const PlanPaymentMethod = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    watch
  } = usePlanPaymentFormContext();
  const planTemplateType = watch('planTemplateType');
  if (planTemplateType === PlanTemplateType.PRODUCT_ONETIME) {
    return null;
  }
  return <>
      <Spacing size={32} data-sentry-element="Spacing" data-sentry-source-file="PlanPaymentMethod.tsx" />
      <Divider data-sentry-element="Divider" data-sentry-source-file="PlanPaymentMethod.tsx" />
      <Spacing size={32} data-sentry-element="Spacing" data-sentry-source-file="PlanPaymentMethod.tsx" />
      <div className="w-full">
        <h2 className="text-[17px] font-[700] text-gray-900">
          {t('subscription:payment.paymentMethod.subTitle', '결제 수단')}
        </h2>
        <Spacing size={14} data-sentry-element="Spacing" data-sentry-source-file="PlanPaymentMethod.tsx" />
        <div className="flex w-full flex-col items-center">
          <CardPaymentRegisterSection data-sentry-element="CardPaymentRegisterSection" data-sentry-source-file="PlanPaymentMethod.tsx" />
        </div>
      </div>
    </>;
};